export default __webpack_public_path__ + "static/favicon-ccaa652d724ce4c933e46c8b2d4469b4.ico";